const NavMenu = () => {
	const block = document.querySelectorAll(".nav-menu");
	if (!block) {
		return;
	}

	const showMorelinks = (item) => {
		const list = item.querySelector(".nav-menu__list");
		const listItem = list.querySelectorAll(".nav-menu__list-item");
		const more = item.querySelector(".nav-menu__more");
		const moreLinks = more.querySelector(".nav-menu__dropdown");
		const moreToggle = more.querySelector(".nav-menu__toggle");

		listItem.forEach((el) => {
			el.classList.remove("hidden");
		});
		more.classList.add("hidden")
		more.classList.remove("active");

		moreLinks.innerHTML = '';
		let lastElement = null;
		let lastOffTop = null;
		let continueSearch = true;
		
		listItem.forEach((el, i) => {
			if (continueSearch) {
				const that = listItem[i];
				const currOffTop = that.offsetTop;
				if (lastOffTop == null) {
					lastOffTop = currOffTop;
				}
				if (currOffTop > lastOffTop) {
					more.classList.remove("hidden");
					if (listItem[i - 1].offsetTop > listItem[i - 2].offsetTop) {
						lastElement = i - 2;
					} else {
						lastElement = i - 1;
					}
					continueSearch = false;
					false;
				}
				lastOffTop = currOffTop;
			}
		});

		if (!continueSearch) {
			list.querySelectorAll(`.nav-menu__list-item:nth-child(n+${lastElement + 2})`).forEach(el => {
				moreLinks.append(el.cloneNode(true));
				el.classList.add("hidden");
			});
		}
	};

	block.forEach(el => {
		showMorelinks(el);

		window.addEventListener("resize", () => {
			showMorelinks(el);
		});
	});
};

export default NavMenu;
